import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "utils/apiService";
import PageHeader from "components/layout/PageHeader";

const FIELDS = [
  { key: "facebook", label: "Facebook" },
  { key: "instagram", label: "Instagram" },
  { key: "twitter", label: "Twitter" },
  { key: "tiktok", label: "TikTok" },
  { key: "whatsapp", label: "WhatsApp" },
  { key: "contactNumber", label: "رقم التواصل" },
];

const AdminContactsEditor = () => {
  const [contacts, setContacts] = useState({
    facebook: "",
    instagram: "",
    twitter: "",
    tiktok: "",
    whatsapp: "",
    contactNumber: "",
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const res = await api.get(`/adminContacts`);
      if (cancelled) return;
      if (res.error) toast.error(res.error);
      else if (res.data) {
        setContacts((prev) => ({
          ...prev,
          ...Object.fromEntries(
            Object.keys(prev).map((k) => [k, res.data[k] ?? ""])
          ),
        }));
      }
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleUpdate = async () => {
    setSaving(true);
    const res = await api.patch(`/adminContacts`, contacts);
    setSaving(false);
    if (res.error) toast.error(res.error);
    else toast.success("تم تحديث جهات الاتصال بنجاح");
  };

  return (
    <div className="mt-6">
      <PageHeader
        title="تحديث جهات الاتصال"
        subtitle="روابط التواصل الاجتماعي ورقم خدمة العملاء"
      />
      <div className="grid gap-4 rounded-2xl border border-border-muted bg-white p-5 shadow-card dark:border-navy-700 dark:bg-navy-800 md:grid-cols-2">
        {FIELDS.map(({ key, label }) => (
          <label key={key} className="flex flex-col gap-1">
            <span className="text-sm font-medium text-gray-700 dark:text-gray-200">
              {label}
            </span>
            <input
              type="text"
              value={contacts[key] || ""}
              onChange={(e) =>
                setContacts((prev) => ({ ...prev, [key]: e.target.value }))
              }
              disabled={loading}
              className="rounded-lg border border-border bg-surface-muted px-3 py-2 text-sm text-navy-700 outline-none transition focus:border-info-500 focus:bg-white dark:border-navy-600 dark:bg-navy-900 dark:text-white"
            />
          </label>
        ))}
      </div>
      <div className="mt-4 flex justify-end">
        <button
          type="button"
          onClick={handleUpdate}
          disabled={loading || saving}
          className="rounded-lg bg-info-600 px-6 py-2 text-sm font-semibold text-white shadow-card transition hover:bg-info-700 disabled:opacity-60"
        >
          {saving ? "جاري التحديث" : "تحديث"}
        </button>
      </div>
    </div>
  );
};

export default AdminContactsEditor;
